(() => {
  const applyTcfV4 = () => {
    const home = document.querySelector('.tcf-home-v35');
    if (!home) return;

    const heroScript = home.querySelector('.tcf-hero-script');
    if (heroScript) heroScript.textContent = 'The past travels with us.';

    const closeLine = home.querySelector('.tcf-close > .page-width > p');
    if (closeLine) closeLine.textContent = 'THE PAST TRAVELS WITH US.';

    const mobileSource = home.querySelector('.tcf-hero-bg source[media*="749"]');
    if (mobileSource) {
      mobileSource.setAttribute('srcset', 'https://cdn.shopify.com/s/files/1/0815/5663/5997/files/tcf-mobile-hero-fixed.png?v=1788781258');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyTcfV4, { once: true });
  } else {
    applyTcfV4();
  }
})();
